import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useAusenciasOutletContext } from 'pages/Ausencias.context'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Abono, abonos } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormDetalhesAbono from 'templates/ManutencaoDoPonto/Digitacao/forms/DetalhesAbono'
import IconeCadeado from './IconeCadeado'
import IconeCompetenciaFutura from './IconeCompetenciaFutura'
import invalidateAusenciasQuery from './invalidateAusenciasQuery'

export default function EditarAbono() {
    const { id } = useParams()
    const { data, competencia } = useAusenciasOutletContext()
    const { mutateAsync } = abonos.mutations.useUpdate()
    const empresa = useStore(state => state.company)
    const row: any = data?.find(a => a.id === 'abono_' + id)
    if (!row || !empresa) return null
    const isEdicaoBloqueada = dayjs(
            empresa.competenciaAtual,
            'YYYY-MM',
        ).isAfter(dayjs(competencia, 'YYYY-MM'), 'month'),
        isCompetenciaFutura = dayjs(
            empresa.competenciaAtual,
            'YYYY-MM',
        ).isBefore(dayjs(competencia, 'YYYY-MM'), 'month')

    const handleSubmit: SubmitHandler<Abono> = data =>
        mutateAsync(
            {
                ...data,
                id: Number(String(row.id).split('_').at(-1)),
                data: dayjs(data.data).toDate(),
            },
            {
                onSuccess: async () => {
                    await invalidateAusenciasQuery()
                    toast.success('Abono editado com sucesso!')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            defaultValues={row}
            onSubmit={isEdicaoBloqueada ? undefined : handleSubmit}
            disableFields={isEdicaoBloqueada}
            open={hasPermission(['update', 'Abonos'])}
        >
            <Dialog.Title>
                Editar Abono {isCompetenciaFutura && <IconeCompetenciaFutura />}
                {isEdicaoBloqueada && <IconeCadeado />}
            </Dialog.Title>
            <Dialog.Content>
                <FormDetalhesAbono />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
